<template>
    <div class="w-full">
        <div>
            <p v-if="programmeChoiceType['num_references_required'] === 1" class="text-left mx-8 mt-4">
                Please give details of your referee
            </p>
            <p v-if="programmeChoiceType['num_references_required'] > 1" class="text-left mx-8 mt-4">
                Please can you provide details of two referees. You should ensure that you use professional/organisation emails as personal email addresses will not be accepted. Your referees will be contacted via email upon submission of your application.
            </p>
            <p v-if="programmeChoiceType['num_references_required'] > 1" class="text-left mx-8 mt-4">
                If you have studied in the last five years, you should include a referee who is an academic familiar with your work. If you are currently or have been recently employed, then the second referee should be your current/recent employer. If you have not been recently employed, then the second referee should be another academic.            </p>
        </div>
        <div class="w-full text-left pl-8 pt-4">* Required fields</div>
        <div class="p-4">
            <div v-for="(record, index) in referees" :key="record" class="w-full">
                <div>
                    <referee-form
                        :referee-data="record"
                        :application-reference="applicationReference"
                        :item-index="index"
                        :countries-of-domicile-list="countriesOfDomicileList"
                        :titles-list="titlesList"
                        :applicant-email="applicantEmail"
                        @delete="removeOne"
                        @refreshApplication="refreshApplication"
                    />
                </div>
            </div>
        </div>

        <div v-if="refereeCount < programmeChoiceType['num_references_required']">
            <button class="btn-green mb-8" @click="newReferee">Add <span v-if="refereeCount > 0">another</span> referee record</button>
        </div>
    </div>
</template>

<script>

import RefereeForm from '@/views/Application/Details/RefereeForm'

export default {
    components: {
        RefereeForm,
    },
    props: {
        refereeData: Object,
        applicationReference: String,
        countriesOfDomicileList: Object,
        programmeChoiceType: Object,
        titlesList: Object,
        applicantEmail: String,
    },
    data() {
        return {
            referees: Object,
            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
            addReference: false,
        }
    },
    computed: {
        refereeCount() {
            return this.referees.length + ((this.addReference === true)? 1: 0)
        },
    },
    mounted() {
        this.referees = this.refereeData

        if (this.referees.length === 0)
        {
            this.newReferee()
        }
    },
    methods: {
        refreshApplication() {
            this.$emit('refreshApplication', true)
        },
        removeOne(index) {
            this.referees.splice(index, 1)
        },
        newReferee() {
            this.referees.push({
                reference: null,
                title: null,
                name: null,
                position: null,
                org: null,
                email: null,
                address_line1: null,
                address_line2: null,
                address_line3: null,
                city_town: null,
                county_state: null,
                post_zip_code: null,
                country_id: null,
                phone_number: null,
                fax_number: null,
            })
        },
    },
}
</script>